// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetails_order-details__id-wrapper__KNBb5 {
  color: var(--primary-color);
  font-size: var(--text-lg);
  margin-bottom: 1rem;
}

.OrderDetails_order-details__id-text__XukGn {
  font-weight: 700;
}

.OrderDetails_order-details__id__lbd4O {
  font-weight: 600;
}

.OrderDetails_order-details__name-wrapper__FB4ZC {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.OrderDetails_order-details__name-title__5ku\\+j {
  color: var(--gray-dark);
  font-size: var(--text-sm);
  font-weight: 500;
}

.OrderDetails_order-details__name__8P9kC {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.OrderDetails_order-details__quantity__UcOnZ {
  color: var(--primary-color);
  font-size: var(--text-base);
  font-weight: 700;
}

.OrderDetails_order-details__total-wrapper__4upCI {
  margin-top: 2rem;
  padding: 1.5rem 2rem;
  border-radius: 0.8rem;
  background-color: var(--gray-extra-light);
  width: max-content;
}

.OrderDetails_order-details__total-wrapper__row__afD7W {
  display: flex;
  align-items: center;
  gap: 2rem;
  justify-content: space-between;
}

.OrderDetails_order-details__total-text__7MkMT {
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}

.OrderDetails_order-details__total-number-wrapper__l9mOb {
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 700;
}

.OrderDetails_order-details__total-number__uTZdQ {
  margin-inline-end: 0.4rem;
}

.OrderDetails_order-details__total-currency__goPuJ {
  font-size: var(--text-sm);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrderDetails/OrderDetails.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".order-details__id-wrapper {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  margin-bottom: 1rem;\n}\n\n.order-details__id-text {\n  font-weight: 700;\n}\n\n.order-details__id {\n  font-weight: 600;\n}\n\n.order-details__name-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.order-details__name-title {\n  color: var(--gray-dark);\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.order-details__name {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.order-details__quantity {\n  color: var(--primary-color);\n  font-size: var(--text-base);\n  font-weight: 700;\n}\n\n.order-details__total-wrapper {\n  margin-top: 2rem;\n  padding: 1.5rem 2rem;\n  border-radius: 0.8rem;\n  background-color: var(--gray-extra-light);\n  width: max-content;\n}\n\n.order-details__total-wrapper__row {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  justify-content: space-between;\n}\n\n.order-details__total-text {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.order-details__total-number-wrapper {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 700;\n}\n\n.order-details__total-number {\n  margin-inline-end: 0.4rem;\n}\n\n.order-details__total-currency {\n  font-size: var(--text-sm);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order-details__id-wrapper": `OrderDetails_order-details__id-wrapper__KNBb5`,
	"order-details__id-text": `OrderDetails_order-details__id-text__XukGn`,
	"order-details__id": `OrderDetails_order-details__id__lbd4O`,
	"order-details__name-wrapper": `OrderDetails_order-details__name-wrapper__FB4ZC`,
	"order-details__name-title": `OrderDetails_order-details__name-title__5ku+j`,
	"order-details__name": `OrderDetails_order-details__name__8P9kC`,
	"order-details__quantity": `OrderDetails_order-details__quantity__UcOnZ`,
	"order-details__total-wrapper": `OrderDetails_order-details__total-wrapper__4upCI`,
	"order-details__total-wrapper__row": `OrderDetails_order-details__total-wrapper__row__afD7W`,
	"order-details__total-text": `OrderDetails_order-details__total-text__7MkMT`,
	"order-details__total-number-wrapper": `OrderDetails_order-details__total-number-wrapper__l9mOb`,
	"order-details__total-number": `OrderDetails_order-details__total-number__uTZdQ`,
	"order-details__total-currency": `OrderDetails_order-details__total-currency__goPuJ`
};
export default ___CSS_LOADER_EXPORT___;
